import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  ArrowRight,
  ChevronDown,
  Copy,
  ImagePlus,
  MoreVertical,
  Plus,
  Trash2,
  X,
} from "lucide-react";
import { DndContext, closestCenter } from "@dnd-kit/core";
import {
  SortableContext,
  arrayMove,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable"; 

import CreateSurveyHero from "../../components/Ui/CreateSurveyHero";
import {
  SortableOption,
  buildQuestionsPayload,
  cloneImageAsset,
  createImageAsset,
  createOption,
  createQuestion,
  dummySurveySummary,
  initialHashtagItems,
  initialQuestions,
  isChoiceQuestion,
  MAX_SURVEY_QUESTIONS,
  questionTypeOptions,
} from "./CreateSurveyShared";
import { toast } from "react-toastify";

const CreateSurveyStep2 = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { surveyId } = useParams();
  
  console.log("Step2 location.state", location.state);
  console.log("Questions from Preview =>", location.state?.questions);

  const surveySummary = location.state?.surveySummary || dummySurveySummary;
  const formData = location.state?.formData;

  const resolvedSurveyTitle =
    surveySummary.surveyTitle?.trim() || dummySurveySummary.surveyTitle;

  // const [questions, setQuestions] = useState(
  //   location.state?.questions || initialQuestions
  // );

  const [questions, setQuestions] = useState(
    location.state?.questions?.length
      ? location.state.questions
      : initialQuestions
  );

  const [hashtagItems, setHashtagItems] = useState(
    location.state?.hashtagItems || initialHashtagItems
  );


  const [tagInput, setTagInput] = useState("");
  const [activeQuestionMenuId, setActiveQuestionMenuId] = useState(null);
  const activeQuestionMenuRef = useRef(null);
  const activeQuestionMenuTriggerRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (activeQuestionMenuId === null) return;

    const closeOnOutsideClick = (event) => {
      if (
        activeQuestionMenuRef.current?.contains(event.target) ||
        activeQuestionMenuTriggerRef.current?.contains(event.target)
      ) return;

      setActiveQuestionMenuId(null);
    };

    const closeOnEscape = (event) => {
      if (event.key === "Escape") setActiveQuestionMenuId(null);
    };

    document.addEventListener("pointerdown", closeOnOutsideClick);
    document.addEventListener("keydown", closeOnEscape);
    return () => {
      document.removeEventListener("pointerdown", closeOnOutsideClick);
      document.removeEventListener("keydown", closeOnEscape);
    };
  }, [activeQuestionMenuId]);

  // const handleBackToDetails = () => {
  //   navigate("/create-survey/step-1");
  // };

  const handleBackToDetails = () => {
    console.log("Back Data", location.state);
    navigate("/create-survey/step-1", {
      state: {
         isBack: true,
         formData: location.state.formData,
         surveyImage: location.state.surveyImage,

          questions,
          hashtagItems,
      },
    });
  };

  const updateQuestionText = (questionId, value) => {
    setQuestions((prev) =>
      prev.map((question) =>
        question.id === questionId ? { ...question, text: value } : question
      )
    );
  };



  // const getQuestionAnswerMode = (question) => {
  //   const hasText = question.options.some(
  //     (option) => option.text.trim() !== ""
  //   );

  //   const hasImage = question.options.some(
  //     (option) => option.image
  //   );

  //   if (hasText) return "text";
  //   if (hasImage) return "image";

  //   return "";
  // };


  const updateQuestionOption = (questionId, optionId, value) => {
    setQuestions((prev) =>
      prev.map((question) => {
        if (question.id !== questionId) return question;

        const nextOptions = question.options.map((option) =>
          option.id === optionId ? { ...option, text: value } : option
        );

        return { ...question, options: nextOptions };
      })
    );
  };

  // const updateQuestionOption = (questionId, optionId, value) => {
  //   setQuestions((prev) =>
  //     prev.map((question) => {
  //       if (question.id !== questionId) return question;

  //       const mode = getQuestionAnswerMode(question);

  //       // if (mode === "image" && value.trim() !== "") {
  //       //   toast.error(
  //       //     "Aap is question me image use kar rahe hain. Sabhi answers image hi hone chahiye."
  //       //   );
  //       //   return question;
  //       // }


  //       if (mode === "image" && value.trim() !== "") {
  //         if (!toast.isActive("answer-mode")) {
  //             toast.error(
  //                 "Aap is question me image use kar rahe hain. Sabhi answers image hi hone chahiye.",
  //                 {
  //                     toastId: "answer-mode",
  //                 }
  //             );
  //         }
  //         return question;
  //       }

  //       return {
  //         ...question,
  //         options: question.options.map((option) =>
  //           option.id === optionId
  //             ? {
  //                 ...option,
  //                 text: value,
  //               }
  //             : option
  //         ),
  //       };
  //     })
  //   );
  // };

  const updateQuestionType = (questionId, value) => {
    setQuestions((prev) =>
      prev.map((question) =>
        question.id === questionId ? { ...question, type: value } : question
      )
    );
  };

  // const updateQuestionImage = (questionId, file) => {
  //   setQuestions((prev) =>
  //     prev.map((question) =>
  //       question.id === questionId
  //         ? { ...question, image: createImageAsset(file) }
  //         : question
  //     )
  //   );
  // };

  // const removeQuestionImage = (questionId) => {
  //   setQuestions((prev) =>
  //     prev.map((question) =>
  //       question.id === questionId ? { ...question, image: null } : question
  //     )
  //   );
  // };

  const addOption = (questionId) => {
    setQuestions((prev) =>
      prev.map((question) =>
        question.id === questionId
          ? { ...question, options: [...question.options, createOption()] }
          : question
      )
    );
  };

  const deleteOption = (questionId, optionId) => {
    setQuestions((prev) =>
      prev.map((question) => {
        if (question.id !== questionId || question.options.length <= 1) {
          return question;
        }

        return {
          ...question,
          options: question.options.filter((option) => option.id !== optionId),
        };
      })
    );
  };

  // const updateOptionImage = (questionId, optionId, file) => {
  //   setQuestions((prev) =>
  //     prev.map((question) => {
  //       if (question.id !== questionId) return question;

  //       return {
  //         ...question,
  //         options: question.options.map((option) =>
  //           option.id === optionId
  //             ? { ...option, image: createImageAsset(file) }
  //             : option
  //         ),
  //       };
  //     })
  //   );
  // };

  // const updateOptionImage = (questionId, optionId, file) => {
  //   setQuestions((prev) =>
  //     prev.map((question) => {
  //       if (question.id !== questionId) return question;

  //       const mode = getQuestionAnswerMode(question);

  //       // if (mode === "text") {
  //       //   toast.error(
  //       //     "Aap is question me text use kar rahe hain. Sabhi answers text hi hone chahiye."
  //       //   );
  //       //   return question;
  //       // }

  //       if (mode === "text") {

  //         if (!toast.isActive("answer-mode")) {
  //             toast.error(
  //                 "Aap is question me text use kar rahe hain. Sabhi answers text hi hone chahiye.",
  //                 {
  //                     toastId: "answer-mode",
  //                 }
  //             );
  //         }

  //         return question;
  //     }

  //       return {
  //         ...question,
  //         options: question.options.map((option) =>
  //           option.id === optionId
  //             ? {
  //                 ...option,
  //                 image: createImageAsset(file),
  //               }
  //             : option
  //         ),
  //       };
  //     })
  //   );
  // };

  // const removeOptionImage = (questionId, optionId) => {
  //   setQuestions((prev) =>
  //     prev.map((question) => {
  //       if (question.id !== questionId) return question;

  //       return {
  //         ...question,
  //         options: question.options.map((option) =>
  //           option.id === optionId ? { ...option, image: null } : option
  //         ),
  //       };
  //     })
  //   );
  // };

  const handleOptionDragEnd = (questionId, event) => {
    const { active, over } = event;

    if (!over || active.id === over.id) {
      return;
    }

    setQuestions((prev) =>
      prev.map((question) => {
        if (question.id !== questionId) return question;

        const oldIndex = question.options.findIndex(
          (option) => option.id === active.id
        );
        const newIndex = question.options.findIndex(
          (option) => option.id === over.id
        );

        if (oldIndex === -1 || newIndex === -1) {
          return question;
        }

        return {
          ...question,
          options: arrayMove(question.options, oldIndex, newIndex),
        };
      })
    );
  };

  const duplicateQuestion = (questionId) => {
    if (questions.length >= MAX_SURVEY_QUESTIONS) {
      toast.error(`Maximum ${MAX_SURVEY_QUESTIONS} questions allowed.`);
      return;
    }

    setQuestions((prev) => {
      if (prev.length >= MAX_SURVEY_QUESTIONS) return prev;

      const questionIndex = prev.findIndex(
        (question) => question.id === questionId
      );
      if (questionIndex === -1) return prev;

      const sourceQuestion = prev[questionIndex];
      const duplicatedQuestion = {
        ...sourceQuestion,
        id: crypto.randomUUID(),
        image: cloneImageAsset(sourceQuestion.image),
        options: sourceQuestion.options.map((option) =>
          createOption(option.text, cloneImageAsset(option.image))
        ),
      };

      const nextQuestions = [...prev];
      nextQuestions.splice(questionIndex + 1, 0, duplicatedQuestion);
      return nextQuestions;
    });
  };

  const deleteQuestion = (questionId) => {
    setQuestions((prev) => {
      if (prev.length <= 1) return prev;
      return prev.filter((question) => question.id !== questionId);
    });
  };

  const addQuestion = () => {
    if (questions.length >= MAX_SURVEY_QUESTIONS) {
      toast.error(`Maximum ${MAX_SURVEY_QUESTIONS} questions allowed.`);
      return;
    }

    setQuestions((prev) => prev.length >= MAX_SURVEY_QUESTIONS ? prev : [...prev, createQuestion()]);
  };

  const addTag = () => {
    const normalizedValue = tagInput.trim().replace(/\s+/g, "");

    if (!normalizedValue || hashtagItems.length >= 9) {
      setTagInput("");
      return;
    }

    const formattedTag = normalizedValue.startsWith("#")
      ? normalizedValue
      : `#${normalizedValue}`;

    const tagExists = hashtagItems.some(
      (tag) => tag.toLowerCase() === formattedTag.toLowerCase()
    );

    if (!tagExists) {
      setHashtagItems((prev) => [...prev, formattedTag]);
    }

    setTagInput("");
  };

  const removeTag = (tagToRemove) => {
    setHashtagItems((prev) => prev.filter((tag) => tag !== tagToRemove));
  };

  const handleTagInputKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      addTag();
    }
  };

  const toggleQuestionMenu = (questionId) => {
    setActiveQuestionMenuId((prev) => (prev === questionId ? null : questionId));
  };

  const buildPostmanFormData = (payload) => {
    const formData = new FormData();

    const postmanQuestions = payload.questions.map((question, questionIndex) => {

      // const questionImageField = question.question_image
      //   ? `question_image_${questionIndex}`
      //   : "";

      const questionPayload = {
        ...question,
        // question_image: questionImageField,
      };

      // if (question.options) {
      //   questionPayload.options = question.options.map((option, optionIndex) => ({
      //     ...option,
      //     option_image: option.option_image
      //       ? `option_image_${questionIndex}_${optionIndex}`
      //       : "",
      //   }));
      // }

      return questionPayload;
    });

    formData.append("survey_id", payload.survey_id);
    formData.append("questions", JSON.stringify(postmanQuestions));
    formData.append("tags", JSON.stringify(payload.tags));

    console.group("Survey questions Postman form-data model");

    payload.questions.forEach((question, questionIndex) => {
      
      // if (question.question_image) {
      //   formData.append(`question_image_${questionIndex}`, question.question_image);
      // }

      // question.options?.forEach((option, optionIndex) => {
      //   if (option.option_image) {
      //     formData.append(
      //       `option_image_${questionIndex}_${optionIndex}`,
      //       option.option_image
      //     );
      //   }
      // });

    });

    console.groupEnd();
    return formData;
  };

  const saveSurveyQuestions = (formData) => {
    const token = localStorage.getItem("token");
    const base = (process.env.REACT_APP_API_URL || "").replace(/\/+$/, "");

    return axios.post(`${base}/api/survey/save-survey-questions`, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
      timeout: 30000,
    });
  };


  // const validateQuestionImages = () => {
//   const invalidQuestions = [];

//   questions.forEach((question, index) => {
//     const options = question.options || [];

//     // Open End me options nahi hote
//     if (options.length === 0) {
//       return;
//     }

//     const imageCount = options.filter(
//       (option) => option.image
//     ).length;

//     // Agar ek bhi image hai to sabhi options me image honi chahiye
//     if (imageCount > 0 && imageCount !== options.length) {
//       invalidQuestions.push(index + 1);
//     }
//   });

//   if (invalidQuestions.length > 0) {
//     toast.error(
//       `Question ${invalidQuestions.join(
//         ", "
//       )}: Agar kisi ek option me image upload ki hai to us question ke sabhi options me image upload karna zaroori hai.`
//     );
//     return false;
//   }

//   return true;
// };

const validateQuestions = () => {
  if (questions.length > MAX_SURVEY_QUESTIONS) {
    toast.error(`Maximum ${MAX_SURVEY_QUESTIONS} questions allowed.`);
    return false;
  }

  for (let i = 0; i < questions.length; i++) {
    const question = questions[i];

    // Question text validation
    if (!question.text.trim()) {
      toast.error(`Please enter Question ${i + 1}.`);
      return false;
    }

    // Options validation (Single Select / Multi Select)
    if (isChoiceQuestion(question.type)) {
      for (let j = 0; j < question.options.length; j++) {
        if (!question.options[j].text.trim()) {
          toast.error(
            `Please enter Option ${j + 1} for Question ${i + 1}.`
          );
          return false;
        }
      }
    }
  }

  return true;
};

  const handleSaveAsDraft = async () => {
    if (!validateQuestions()) return;
     
    const payload = buildQuestionsPayload(surveyId, questions, hashtagItems);
    const requestFormData = buildPostmanFormData(payload);

    console.log("Handle SaveAs payload Check ===========>" , payload);

    try {
      const response = await saveSurveyQuestions(requestFormData);

      if (response.status === 200 || response.status === 201) {
              toast.success("Survey saved as draft");
            }
    } catch (error) {
      console.error("Draft API Error =>", error);
      toast.error("Failed to save draft");
    }
  };



  const handleOpenPreview = async () => {

    // if (!validateQuestionImages()) {
    //   return;
    // }

    if (!validateQuestions()) return;

    const payload = buildQuestionsPayload(surveyId, questions, hashtagItems);
    const requestFormData = buildPostmanFormData(payload); 

    console.log("Handle Open payload Check ===========>" , payload);    

    try {
      setIsLoading(true);

      await saveSurveyQuestions(requestFormData);
      // navigate(`/create-survey/preview/${surveyId}`);
      console.log("Before Navigate =>", {
        formData: location.state?.formData,
        surveyImage: location.state?.surveyImage,
        surveySummary: location.state?.surveySummary,
        questions,
        hashtagItems,
      });

      navigate(`/create-survey/preview/${surveyId}`, {
        state: {
          formData: location.state?.formData,
          surveyImage: location.state?.surveyImage,
          surveySummary: location.state?.surveySummary,

          questions,
          hashtagItems,
        },
      });

    } catch (error) {
      console.error("API Error =>", error);
    } finally {
      setIsLoading(false);
    }

    
  };

  return (

    <>
      {isLoading && (
        <div className="position-fixed top-0 start-0 w-100 h-100 bg-white bg-opacity-75 d-flex justify-content-center align-items-center"
            style={{ zIndex: 9999 }}>
          <div
            className="spinner-border text-danger"
            style={{ width: "3rem", height: "3rem" }}
            role="status"
          >
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      )}
      
      
      <div className="dashboard-create-survey">
        <CreateSurveyHero
          currentStep={2}
          handleBackToDetails={handleBackToDetails}
        />

        <div className="row g-3">
          <div className="col-12">
            <div className="cs-card cs-form-card">
              <div className="cs-step-label">Step 2/3: Add questions and options</div>
              <div className="cs-progress-track">
                <div className="cs-progress-fill step-2"></div>
              </div>

              <div className="cs-title-preview">
                <small>Survey Title</small>
                <span>{resolvedSurveyTitle}</span>
              </div>

              <div className="row g-3">
                <div className="col-12">
                  {questions.map((question, index) => (
                    <div className="cs-question-card" key={question.id}>
                      <div className="row g-2 align-items-start">
                        <div className="col-12 col-md">
                          <div className="cs-question-title">Question {index + 1}</div>
                        </div>
                        <div className="col-12 col-md-auto">
                          <div className="d-flex flex-wrap gap-2 justify-content-md-end cs-question-menu-wrap">
                            <div className="cs-question-type-wrap">
                              <select
                                value={question.type}
                                onChange={(e) =>
                                  updateQuestionType(question.id, e.target.value)
                                }
                                className="cs-type-pill cs-question-type-select"
                              >
                                {questionTypeOptions.map((typeOption) => (
                                  <option key={typeOption} value={typeOption}>
                                    {typeOption}
                                  </option>
                                ))}
                              </select>
                              <ChevronDown size={18} className="cs-field-icon" />
                            </div>
                            <button
                              type="button"
                              className="text-black"
                              ref={activeQuestionMenuId === question.id ? activeQuestionMenuTriggerRef : null}
                              onClick={() => toggleQuestionMenu(question.id)}
                            >
                              <MoreVertical size={20} />
                            </button>

                            {activeQuestionMenuId === question.id && (
                              <div className="cs-question-menu" ref={activeQuestionMenuRef}>
                                <div className="d-flex gap-4 flex-column w-100">
                                  <button
                                    type="button"
                                    className="cs-action-link"
                                    onClick={() => {
                                      duplicateQuestion(question.id);
                                      setActiveQuestionMenuId(null);
                                    }}
                                  >
                                    <Copy size={20} />
                                    <span>Duplicate</span>
                                  </button>
                                  <button
                                    type="button"
                                    className="cs-action-link delete"
                                    onClick={() => {
                                      deleteQuestion(question.id);
                                      setActiveQuestionMenuId(null);
                                    }}
                                  >
                                    <Trash2 size={20} />
                                    <span>Delete</span>
                                  </button>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="row g-2 mt-1">
                        <div className="col-12">
                          <input
                            type="text"
                            value={question.text}
                            // onChange={(e) =>
                            //   updateQuestionText(question.id, e.target.value)
                            // }
                            onChange={(e) => updateQuestionText(question.id, e.target.value)}
                            placeholder="Enter Your Question"
                            className="cs-input"
                          />
                        </div>

                        {/* <div className="col-12 col-md-12 mb-3 mt-3">
                          <div className="survey-upload-wrapper">
                            <label className="survey-upload-label ft-14 inter graytext mb-2">
                              Question Image <span>(Optional)</span>
                            </label>

                            <div className="survey-upload-box">
                              <input
                                type="file"
                                accept=".jpg,.jpeg,.png,.webp"
                                id={`question-image-${question.id}`}
                                onChange={(e) => {
                                  const file = e.target.files?.[0];

                                  if (!file) {
                                    return;
                                  }

                                  updateQuestionImage(question.id, file);
                                  e.target.value = "";
                                }}
                                hidden
                              />

                              {!question.image ? (
                                <label
                                  htmlFor={`question-image-${question.id}`}
                                  className="upload-placeholder text-center cs-question-upload-placeholder"
                                >
                                  <div className="upload-icon">
                                    <ImagePlus size={30} />
                                  </div>

                                  <h6 className="ft-14 fw-semibold inter">
                                    + Upload Question Image
                                  </h6>

                                  <p className="ft-12 inter">
                                    Supported: JPG, PNG, WEBP (Max 5MB)
                                  </p>
                                </label>
                              ) : (
                                <div className="preview-container cs-question-image-preview">
                                  <img
                                    src={question.image.preview}
                                    alt={`Question ${index + 1}`}
                                    className="preview-image"
                                  />

                                  <div className="upload-actions text-center d-flex gap-3 justify-content-center py-3">
                                    <button
                                      type="button"
                                      className="btn btn-primary w-33 fw-bold ft-14 text-white px-5 py-3 bgred rounded-2 cursor-target text-center hover:tw-bg-[#333]"
                                      onClick={() =>
                                        document
                                          .getElementById(
                                            `question-image-${question.id}`
                                          )
                                          ?.click()
                                      }
                                    >
                                      Upload New
                                    </button>

                                    <button
                                      type="button"
                                      className="w-33 fw-bold ft-14 text-white px-5 py-3 bgred rounded-2 cursor-target text-center hover:tw-bg-[#333]"
                                      onClick={() => removeQuestionImage(question.id)}
                                    >
                                      Delete
                                    </button>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div> */}

                        <div className="col-12">
                          {isChoiceQuestion(question.type) && (
                            <DndContext
                              collisionDetection={closestCenter}
                              onDragEnd={(event) =>
                                handleOptionDragEnd(question.id, event)
                              }
                            >
                              <SortableContext
                                items={question.options.map((option) => option.id)}
                                strategy={verticalListSortingStrategy}
                              >
                                {question.options.map((option, optionIndex) => (
                                  <SortableOption
                                    key={option.id}
                                    option={option}
                                    optionIndex={optionIndex}
                                    questionId={question.id}
                                    updateQuestionOption={updateQuestionOption}
                                    // updateOptionImage={updateOptionImage}
                                    // removeOptionImage={removeOptionImage}
                                    deleteOption={deleteOption}
                                  />
                                ))}
                              </SortableContext>
                            </DndContext>
                          )}
                        </div>

                        {isChoiceQuestion(question.type) && (
                          <div className="col-12">
                            <button
                              type="button"
                              className="cs-add-option-btn"
                              onClick={() => addOption(question.id)}
                            >
                              <Plus size={16} />
                              <span>Add Option</span>
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>

                <div className="col-12">
                  <button
                    type="button"                  
                    className={`cs-add-question-btn ${
                        questions.length >= MAX_SURVEY_QUESTIONS ? "opacity-50" : ""
                      }`}
                    onClick={addQuestion}
                    disabled={questions.length >= MAX_SURVEY_QUESTIONS}
                  >
                    <Plus size={16} />
                    {/* <span>Add Question</span> */}
                    <span>
                      {questions.length >= MAX_SURVEY_QUESTIONS ? `Maximum ${MAX_SURVEY_QUESTIONS} Questions Allowed` : "Add Question"}
                    </span>
                  </button>
                </div>

                <div className="col-12 mt-5">
                  <div className="cs-tags-card">
                    <div className="cs-section-label mb-3">Survey Tags/Hashtag</div>
                    <div className="cs-tags-row">
                      {hashtagItems.map((tag) => (
                        <div className="cs-tag-pill" key={tag}>
                          <span>{tag}</span>
                          <button
                            type="button"
                            className="cs-tag-remove"
                            onClick={() => removeTag(tag)}
                            aria-label={`Remove ${tag}`}
                          >
                            <X size={12} />
                          </button>
                        </div>
                      ))}

                      {hashtagItems.length < 9 && (
                      <input
                        type="text"
                        value={tagInput}
                        onChange={(e) => setTagInput(e.target.value)}
                        onKeyDown={handleTagInputKeyDown}
                        placeholder={
                          hashtagItems.length >= 9
                            ? "Tag limit reached"
                            : "Add more tags..."
                        }
                        disabled={hashtagItems.length >= 9}
                        className="cs-input"
                        style={{
                          maxWidth: "180px",
                          height: "32px",
                          padding: "6px 10px",
                          fontSize: "12px",
                        }}
                      />)}
                    </div>

                    <div className="d-flex gap-3 justify-content-between">
                        {hashtagItems.length >= 9 ?
                        <div className="cs-section-helper mb-0" style={{color:"#C72430"}}>
                        Tag limit reached
                      </div> :
                      <div className="cs-section-helper mb-0">
                        These help participants discover your survey
                      </div>
                      }
                      <div className="cs-tag-count">{hashtagItems.length}/9</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-12">
            <div className="cs-card cs-actions-card">
              <div className="row g-4 justify-content-end">
                <div className="col-12 col-sm-auto">
                  <button
                    type="button"
                    className="cs-draft-btn w-100"
                    onClick={handleSaveAsDraft}
                  >
                    Save as Draft
                  </button>
                </div>
                <div className="col-12 col-sm-auto">
                  <button
                    type="button"
                    className="cs-primary-btn d-flex align-items-center justify-content-center gap-2 w-100"
                    onClick={handleOpenPreview}
                  >
                    <span>Preview Survey</span>
                    <ArrowRight size={15} />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreateSurveyStep2;
